import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Modal from "../Shared/Modal";
import { connect } from "react-redux";
import { setCause, startGetCause, startGetHighlightedCause } from "../../redux/Market/market.actions";
import marketTypes from "../../redux/Market/market.types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const InsufficientKarmaModal = ({
    isVisible,
    highlightedCause,
    dispatchStartGetCause,
    dispatchStartLoader,
    dispatchStartGetHighlightedCause,
    cleanCause,
}) => {

    const fallbackCauseId = 449;

    const history = useHistory();

    const { t } = useTranslation();

    const handleHighlightedCauseClick = () => {
        cleanCause();
        dispatchStartLoader();
        dispatchStartGetCause(highlightedCause?.cause?.id || fallbackCauseId);
        history.push('/donation');
    }

    useEffect(() => {
        if(!highlightedCause?.cause) {
            dispatchStartGetHighlightedCause();
        }
    }, []);

    const htmlCauseDescription = {__html: highlightedCause?.cause?.description || t("cause.default_highlighted_description")};

    return(
        <Modal isVisible={isVisible}>
            <div>
                <p>{t("cart.insufficient_karma_modal.message")}</p>
                <button 
                    className="w-full relative border border-primary rounded-md p-4 mt-6 btn-effects"
                    onClick={handleHighlightedCauseClick}
                >
                    <div className="absolute -top-2.5 left-4 bg-white px-2 text-sm font-semibold text-primary">
                        <h2>{t("general.highlighted_cause")}</h2>
                    </div>
                    <div className="flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 sm:items-center">
                        {highlightedCause?.cause?.image_url && (
                            <img
                                src={highlightedCause?.cause?.image_url}
                                className="self-center w-1/2"
                            />
                        )}
                        <div className="flex flex-col gap-y-2 items-start">
                            <h1 className="font-semibold">{highlightedCause?.cause?.title || t("cause.default_highlighted_title")}</h1>
                            <p className="text-sm text-start break-words line-clamp-4" dangerouslySetInnerHTML={htmlCauseDescription}/>
                        </div>
                    </div>
                </button>
                <h4
                    className="btn-effects text-hover underline text-primary mt-4"
                    onClick={() => history.push("/")}
                >
                    {t("general.other_causes")}
                </h4>
            </div>
        </Modal>
    );
}

const mapStateToProps = ({ market }) => ({
    highlightedCause: market.highlightedCause,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchStartGetCause: (id) => dispatch(startGetCause(id)),
    dispatchStartLoader: () => dispatch({ type: marketTypes.START_LOADER }),
    dispatchStartGetHighlightedCause: () => dispatch(startGetHighlightedCause()),
    cleanCause: () => dispatch(setCause()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InsufficientKarmaModal);